import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request } from "@/js/http/http_request";
import { isProfessional, isWholesaler, isHolding, isConsultantNotHolding } from "@/js/http/auth";
import BankAccountListComponent from "@/components/stripe/BankAccountListComponent.vue";
import CreditCardListComponent from "@/components/stripe/CreditCardListComponent.vue";
import WholesalersData from "@/components/payment/WholesalersData.vue";
export default {
  name: "userWallet",
  data: function data() {
    return {
      isLoading: false,
      isLoadingStripe: false,
      tab: null,
      user: {
        default_currency: "EUR"
      },
      stripe: null,
      card: null,
      client_secret: "",
      customer: "",
      list_bank_accounts: [],
      list_credit_cards: [],
      list_us_bank_accounts: [],
      listDefaults: []
    };
  },
  computed: {
    canManageWallet: function canManageWallet() {
      return !this.isCreditCardsForbidden || this.hasSepaAccess;
    },
    isConsultantAsHoreca: function isConsultantAsHoreca() {
      var _this$user;
      return isConsultantNotHolding(this.loggedUserData) && ((_this$user = this.user) === null || _this$user === void 0 || (_this$user = _this$user.company_name) === null || _this$user === void 0 ? void 0 : _this$user.length) > 0;
    },
    hasSepaAccess: function hasSepaAccess() {
      return this.user.default_currency === "EUR" && (isProfessional(this.loggedUserData) || isWholesaler(this.loggedUserData) || isHolding(this.loggedUserData) || this.isConsultantAsHoreca);
    },
    hasAchAccess: function hasAchAccess() {
      return this.user.default_currency === "USD" && (isProfessional(this.loggedUserData) || isWholesaler(this.loggedUserData) || isHolding(this.loggedUserData) || this.isConsultantAsHoreca);
    },
    isCreditCardsForbidden: function isCreditCardsForbidden() {
      var _this$user$delivery_a, _this$user$delivery_a2;
      return (isProfessional(this.loggedUserData) || isWholesaler(this.loggedUserData) || this.isConsultantAsHoreca) && ((_this$user$delivery_a = this.user.delivery_address) === null || _this$user$delivery_a === void 0 ? void 0 : _this$user$delivery_a.country.iso_code) === "USA" && ["NY", "NJ"].includes((_this$user$delivery_a2 = this.user.delivery_address) === null || _this$user$delivery_a2 === void 0 || (_this$user$delivery_a2 = _this$user$delivery_a2.state) === null || _this$user$delivery_a2 === void 0 ? void 0 : _this$user$delivery_a2.iso_state);
    },
    numberOfPaymentMethods: function numberOfPaymentMethods() {
      var _this$list_credit_car, _this$list_bank_accou, _this$list_us_bank_ac;
      return +((_this$list_credit_car = this.list_credit_cards) === null || _this$list_credit_car === void 0 ? void 0 : _this$list_credit_car.length) + +((_this$list_bank_accou = this.list_bank_accounts) === null || _this$list_bank_accou === void 0 ? void 0 : _this$list_bank_accou.length) + +((_this$list_us_bank_ac = this.list_us_bank_accounts) === null || _this$list_us_bank_ac === void 0 ? void 0 : _this$list_us_bank_ac.length);
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.includeStripe("js.stripe.com/v3/", function () {
              this.configureStripe();
            }.bind(_this2));
          case 2:
            _context.next = 4;
            return _this2.loadData();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  components: {
    CreditCardListComponent: CreditCardListComponent,
    BankAccountListComponent: BankAccountListComponent,
    WholesalersData: WholesalersData
  },
  props: {
    loggedUserData: Object
  },
  methods: {
    includeStripe: function includeStripe(URL, callback) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var documentTag, tag, object, scriptTag;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              documentTag = document, tag = "script", object = documentTag.createElement(tag), scriptTag = documentTag.getElementsByTagName(tag)[0];
              object.src = "//" + URL;
              if (callback) {
                object.addEventListener("load", function (e) {
                  callback(null, e);
                }, false);
              }
              scriptTag.parentNode.insertBefore(object, scriptTag);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    configureStripe: function configureStripe() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isLoadingStripe = true;
              _context3.next = 3;
              return request("/v1/stripe/publishable-key", "get", null, true, "api");
            case 3:
              response = _context3.sent;
              _this3.stripe = Stripe(response.data.value);
              _this3.isLoadingStripe = false;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    loadData: function loadData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this4;
              _this4.isLoading = true;
              Promise.all([_this4.loadLists(), _this4.setupIntent(), request("/v1/user", "get", null, true, "api").then(function (response) {
                _this.user = _objectSpread({}, response.data);
              })]).then(function () {
                _this.isLoading = false;
              });
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    loadLists: function loadLists() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.listDefaults = [];
              _this = _this5;
              request("/v1/stripe/payment-methods", "get", null, true, "api").then(function (response) {
                _this.list_bank_accounts = _toConsumableArray(response.data.list_bank_accounts);
                _this.list_credit_cards = _toConsumableArray(response.data.list_credit_cards);
                _this.list_us_bank_accounts = _toConsumableArray(response.data.list_us_bank_accounts);
                if (_this.list_bank_accounts.length > 0) {
                  _this.list_bank_accounts.filter(function (x) {
                    return x.default;
                  }).forEach(function (bank) {
                    _this.listDefaults.push({
                      paymentMethodId: bank.payment_method_id,
                      isBankAccount: true,
                      typeLabel: "Bank account",
                      numberLabel: "".concat(bank.country, "**").concat(bank.bank_name, "******").concat(bank.last4)
                    });
                  });
                }
                if (_this.list_credit_cards.length > 0) {
                  _this.list_credit_cards.filter(function (x) {
                    return x.default;
                  }).forEach(function (bank) {
                    _this.listDefaults.push({
                      paymentMethodId: bank.payment_method_id,
                      isBankAccount: false,
                      typeLabel: "Credit card",
                      numberLabel: "**** **** **** ".concat(bank.last4, " (0").concat(bank.exp_month, "/").concat(bank.exp_year, ")")
                    });
                  });
                }
                if (_this.list_us_bank_accounts.length > 0) {
                  _this.list_us_bank_accounts.filter(function (x) {
                    return x.default;
                  }).forEach(function (bank) {
                    _this.listDefaults.push({
                      paymentMethodId: bank.payment_method_id,
                      isBankAccount: true,
                      typeLabel: "Bank account",
                      numberLabel: "".concat(bank.routing_number, "**").concat(bank.bank_name, "******").concat(bank.last4)
                    });
                  });
                }
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setupIntent: function setupIntent() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this6;
              request("/v1/stripe/setup-intent", "get", null, true, "api").then(function (response) {
                _this.client_secret = response.data.client_secret;
                _this.customer = response.data.customer;
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    bankSaved: function bankSaved() {
      this.$toasted.show("Bank account saved.", {
        type: "success"
      });
      this.setupIntent();
      this.loadLists();
    },
    cardSaved: function cardSaved() {
      this.$toasted.show("Credit card saved.", {
        type: "success"
      });
      this.setupIntent();
      this.loadLists();
    },
    bankUpdated: function bankUpdated() {
      this.$toasted.show("Bank account updated.", {
        type: "success"
      });
      this.loadLists();
    },
    cardUpdated: function cardUpdated() {
      this.$toasted.show("Credit card updated.", {
        type: "success"
      });
      this.loadLists();
    },
    bankDeleted: function bankDeleted() {
      this.$toasted.show("Bank account deleted.", {
        type: "success"
      });
      this.loadLists();
    },
    cardDeleted: function cardDeleted() {
      this.$toasted.show("Credit card deleted.", {
        type: "success"
      });
      this.loadLists();
    },
    isHolding: isHolding
  }
};